import type { Content } from '../../typings'
import type { ChangeContent } from './typings'

export const changeContentActionCreator = (
  payload: Content,
): ChangeContent => ({
  type: 'activities/changeContent',
  payload,
})
